const common = {
  siteName: '红桃视频在线观看',
  siteDescription: '免费高清视频播放平台，海量资源即点即播',
  nav: {
    home: '首页',
    category: '分类',
    about: '关于我们',
  },
  footer: {
    copyright: '© 2026 红桃视频在线观看 版权所有',
    privacy: '隐私政策',
    terms: '服务条款',
    contact: '联系我们',
    slogan: '红桃视频在线观看 — 免费高清视频播放平台，每日更新，即点即播',
  },
  breadcrumb: {
    home: '首页',
    category: '分类',
    about: '关于我们',
  },
  article: {
    viewCount: '次播放',
    publishDate: '发布于',
    relatedArticles: '相关推荐',
    backToList: '返回列表',
    prevArticle: '上一篇',
    nextArticle: '下一篇',
  },
  seo: {
    homepageTitle: '红桃视频在线观看 - 免费高清视频播放平台',
    homepageDesc: '红桃视频在线观看，提供海量高清视频资源，无需下载即点即播，支持手机、平板、电脑多端畅看。红桃视频在线观看体验流畅，内容丰富，每日更新，满足您的观影需求。',
    categoryTitle: '{{name}} - 红桃视频在线观看',
    categoryDesc: '红桃视频在线观看{{name}}分类，精选高清视频资源，免费在线观看。每日更新最新{{name}}内容，即点即播，流畅体验。',
    articleTitle: '{{title}} - 红桃视频在线观看',
    articleDesc: '红桃视频在线观看为您带来：{{title}}。高清画质，流畅播放，尽在红桃视频在线观看。',
    aboutTitle: '关于我们 - 红桃视频在线观看',
    aboutDesc: '了解红桃视频在线观看的品牌故事、发展历程、信誉保障及联系方式。红桃视频在线观看致力于为用户提供优质免费高清视频服务。',
  },
};

export default common;